module.exports = __webpack_public_path__ + "static/img/challenge_ok.d4b6183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/challenge_ok.png
// module id = 316
// module chunks = 9